import React from "react";
import { useHistory } from "react-router-dom";
import { User } from "../../storage/store";
import AppDeviceCard from "./app/AppDeviceCard";
import { sensorIconFlag, sensorState, sensorType } from "./sensorStatus";
import { DEVICE_TYPES } from "../../constants/devices";

// Sensor card as in the mobile app: it lights up while the sensor is armed, the
// icon follows the sensor's state, and a click opens the details.
const SensorCard = ({ props }) => {
  const devices = props;
  const navigate = useHistory();
  const kind = sensorType(devices);
  const flags = devices.props ?? {};
  const state = sensorState(kind, flags);

  return (
    <AppDeviceCard
      name={devices.name}
      floor={devices.floor}
      room={devices.room}
      timeStamp={flags.timeStamp}
      type={kind}
      active={flags.state === true}
      iconActive={sensorIconFlag(kind, flags)}
      colorActive={flags.isClosed ?? null}
      centerIcon={kind !== DEVICE_TYPES.SMART_LOCK}
      ariaLabel={`${devices.name}${state ? `, ${state.label}` : ""}. Open details`}
      onOpen={() => navigate.push("/device", { data: devices, propertyId: User.getPropertyId() })}
    />
  );
};
export default SensorCard;
